require("@rails/ujs").start()

require("trix")
require("@rails/actiontext")
require('jquery')

import "./console/services";
import "./console/service_times";
import "./console/service_agreements";
import "./console/thanks_mails";
import "./console/custom_forms";
import "./console/integrations";
import "./console/copy_content";
import "./console/dropdown_menu";
import "./console/toast_hook";

// For Trix editor (Prevent file accept event)
window.addEventListener("trix-file-accept", function(event) {
  event.preventDefault()
  alert("画像ファイルの挿入を利用することはできません")
})

$(function() {
  // フォーム編集中にページ遷移しようとした場合に警告のアラートを出すための処理
  // form要素に'with-editing-alert'クラスがついている時だけ処理の対象にする
  if ($('.with-editing-alert').length) {
    var dirtyFormFlg = false;

    const alertCallback = function(e) {
      if (dirtyFormFlg) {
        e.preventDefault();
        e.returnValue = 'このサイトを離れますか？行った変更が保存されない可能性があります。';
        return 'このサイトを離れますか？行った変更が保存されない可能性があります。';
      }
    };
    window.addEventListener('beforeunload', alertCallback);

    $('.with-editing-alert input').on('change', function() { dirtyFormFlg = true; });
    $('.with-editing-alert input').on('keydown', function() { dirtyFormFlg = true; });
    $('.with-editing-alert textarea').on('change', function() { dirtyFormFlg = true; });
    $('.with-editing-alert textarea').on('keydown', function() { dirtyFormFlg = true; });
    $('.with-editing-alert trix-editor').on('keydown', function() { dirtyFormFlg = true; });
    $('.with-editing-alert select').on('change', function() { dirtyFormFlg = true; });

    $('.with-editing-alert').on('submit', function() {
      window.removeEventListener('beforeunload', alertCallback);
    });
  }
});
